var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mit-borrowed-list"},[_c('MitDataTableClient',{attrs:{"title":"Borrowed","editable":false,"headers":_vm.headers,"items":_vm.borrowed},scopedSlots:_vm._u([{key:"item.spacesDisplay",fn:function(ref){
var item = ref.item;
var search = ref.search;
return [_c('MitKeySpaces',{attrs:{"search":search,"spaces":item.spacesDisplay,"spacesDetails":item.spaces}})]}},{key:"item.spacesDisplay-mobile",fn:function(ref){
var item = ref.item;
var search = ref.search;
return [_c('span',[_vm._v(" Spaces:"),_c('MitKeySpaces',{attrs:{"size":"small","dark":false,"search":search,"spaces":item.spacesDisplay,"spacesDetails":item.spaces}}),_c('br')],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }